
export default {
  name: 'Field',

  props: {
    name: {
      type: String,
      required: true,
      default: undefined
    },

    validateAs: {
      type: String,
      default: undefined
    },

    // this can be used to identify individual elements in a loop
    optionalKey: {
      type: String,
      default: ''
    },

    hasMargin: {
      type: Boolean,
      default: true
    },

    rules: {
      type: [String, Object],
      default: null
    },

    // Label will be created from name prop using translation in en-GB.json -> formFields[this.name]
    autoGenerateLabel: {
      type: Boolean,
      default: true
    },

    label: {
      type: String,
      default: undefined
    },

    actionLabel: {
      type: String,
      default: null
    },

    actionIcon: {
      type: Object,
      default: null
    },

    hint: {
      type: String,
      default: null
    },

    prefixHint: {
      type: String,
      default: null
    },

    isOptional: {
      type: Boolean,
      default: false
    },

    isHidden: {
      type: Boolean,
      default: false
    },

    hasLargeMargin: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    compLabel() {
      if (!this.autoGenerateLabel) {
        return false
      }

      if (this.label) {
        return this.label
      }

      return this.$t(`formFields.${this.name}`)
    },

    compHasRules() {
      return this.rules && this.rules !== ''
    }
  }
}
